import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { BackIcon } from '@/components/icons'
import '@/components/ui/IconButton.css'
import './navigation.css'

export type PageHeaderProps = {
  title: string
  subtitle?: string
  /** Route target for the back control (aria-label 'Terug'). */
  backTo?: string
  /** Trailing actions, typically IconButtons. */
  actions?: ReactNode
}

export function PageHeader({ title, subtitle, backTo, actions }: PageHeaderProps) {
  return (
    <header className="page-header">
      <div className="page-header__row">
        {backTo && (
          <Link to={backTo} className="ui-icon-btn ui-icon-btn--ghost page-header__back" aria-label="Terug">
            <BackIcon size={22} />
          </Link>
        )}
        <div className="page-header__text">
          <h1 className="page-header__title">{title}</h1>
          {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="page-header__actions">{actions}</div>}
      </div>
    </header>
  )
}
